import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Transition } from 'react-transition-group';
import { ErrorNotification, InfoNotification, SuccessNotification, WarningNotification } from '../Alert/Alert';
import { withTranslate } from '../util';
import { StyledNotification } from './Notification.styled';
var _Notification = /*#__PURE__*/function (_React$Component) {
  function _Notification() {
    var _this;
    _classCallCheck(this, _Notification);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _Notification, [].concat(args));
    _defineProperty(_this, "timer", void 0);
    _defineProperty(_this, "state", {
      notificationExpired: false
    });
    _defineProperty(_this, "startTimer", function () {
      if (_this.props.notification.timeout !== 0) {
        _this.timer = window.setTimeout(_this.removeNotification, _this.props.notification.timeout);
      }
    });
    _defineProperty(_this, "removeNotification", function () {
      _this.setState({
        notificationExpired: true
      });
      _this.props.onRemoveNotification(_this.props.notification);
    });
    _defineProperty(_this, "handleMouseEnter", function () {
      if (_this.timer) {
        window.clearTimeout(_this.timer);
      }
    });
    _defineProperty(_this, "handleMouseLeave", function () {
      _this.startTimer();
    });
    return _this;
  }
  _inherits(_Notification, _React$Component);
  return _createClass(_Notification, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps["in"] && !this.props["in"]) {
        this.setState({
          notificationExpired: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var Alert = this.getAlert();
      return /*#__PURE__*/React.createElement(Transition, {
        appear: true,
        "in": !this.state.notificationExpired,
        mountOnEnter: true,
        onEntered: this.startTimer,
        timeout: {
          enter: 0,
          exit: 250
        },
        unmountOnExit: true
      }, function (animationState) {
        return /*#__PURE__*/React.createElement(StyledNotification, {
          animationState: animationState,
          onMouseEnter: _this2.handleMouseEnter,
          onMouseLeave: _this2.handleMouseLeave,
          role: "alertdialog"
        }, /*#__PURE__*/React.createElement(Alert, {
          onDismiss: _this2.removeNotification,
          action: _this2.getAction()
        }, _this2.props.notification.content));
      });
    }
  }, {
    key: "getAction",
    value: function getAction() {
      var _this$props = this.props,
        notification = _this$props.notification,
        t = _this$props.t;
      if (notification.action) {
        return notification.action;
      }
      if (notification.timeout) {
        return undefined;
      }
      return {
        onClick: this.removeNotification,
        children: t('citrix-ui:close')
      };
    }
  }, {
    key: "getAlert",
    value: function getAlert() {
      switch (this.props.notification.type) {
        case 'Error':
          return ErrorNotification;
        case 'Info':
          return InfoNotification;
        case 'Success':
          return SuccessNotification;
        case 'Warning':
          return WarningNotification;
      }
    }
  }]);
}(React.Component);
export var Notification = withTranslate(_Notification);